import Interface from "../../../../interfaces/Interfaceable.js";

const ActionCenterInterface = new Interface("SocketListener", [
	"connect",
	"platform_manager_action_item_created",
	"platform_manager_action_item_updated",
]);

export default ActionCenterInterface;
